import {
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography } from '../../ui';
import React from 'react';
import {
  isEmpty
} from '../../../constants/constant';

const BuildDelItemDisplayData = ({ delItems }) => {
    return (
        <>
            {(Array.isArray(delItems) && delItems.length > 0) &&
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} lg={12} sm={12}>
                        <Typography variant="p" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                            Previously Deleted Items
                        </Typography>
                    </Grid>
                    <Grid item md={12} xs={12} lg={12} sm={12}>
                        <TableContainer component={Paper}>
                            <Table aria-label="simple table" className="rate_card">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Item</TableCell>
                                        <TableCell align="center">Qty</TableCell>
                                        <TableCell align="center">Reason</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {delItems.map((singleItems , index) => {
                                        return (
                                            <TableRow
                                                key={index}
                                                className="rate_card--row"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell align="center"><p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{singleItems.name + " " + (!isEmpty(singleItems.foodQuantityName) ? "(" + singleItems.foodQuantityName + ")" : "")}</p></TableCell>
                                                <TableCell align="center">{singleItems.quantity}</TableCell>
                                                <TableCell align="center"><p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{singleItems.delReason}</p></TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer></Grid></Grid>
            }
        </>
    );
}

export default BuildDelItemDisplayData;